import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const ReferenciaBancariaRow=({referenciabancaria, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{referenciabancaria.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{referenciabancaria.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/referenciabancaria/"+referenciabancaria.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(referenciabancaria.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={referenciabancaria.idEstatus==1?'x':'check'} link  size="large" 
                                                color={referenciabancaria.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(referenciabancaria.id)} 
                                            />
                                        }
                                        content={referenciabancaria.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default ReferenciaBancariaRow;